import { Alert } from "antd";
import { observer } from "mobx-react";
import { _i, __ } from "../../../../utils";
import { useStores } from "../../../../store";
const DEFAULT_COMMISSION = 25;
const AccountAffiliateSignUpSidebar = observer(_ref => {
  let {
    invite
  } = _ref;
  const {
    accountStore
  } = useStores();
  const {
    affiliateManufacturer
  } = accountStore;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 25,
      fontWeight: "bold"
    }
  }, __("Sign up for our affiliate programs")), /*#__PURE__*/React.createElement("p", {
    style: {
      marginBottom: 10
    }
  }, __("You want to recommend %s products to your customers or produce content about them? Earn money in our affiliate program for every sale you refer! If you join our affiliate program, we can offer you the following conditions:", affiliateManufacturer.name.replace("GmbH", ""))), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, invite !== null && invite !== void 0 && invite.commissionPlannedInMonth ? _i(__("{{strong}}{{s}}%1$d %%{{/s}} %2$d %% commissions (for the first %3$d months after registration, thereafter %4$d %% commissions){{/strong}} on all referred sales", DEFAULT_COMMISSION, invite.commission, invite.commissionPlannedInMonth, invite.commissionPlanned), {
    strong: /*#__PURE__*/React.createElement("strong", {
      style: {
        color: "darkgreen"
      }
    }),
    s: /*#__PURE__*/React.createElement("s", {
      style: {
        color: "black"
      }
    })
  }) : invite !== null && invite !== void 0 && invite.commission ? _i(__("{{strong}}{{s}}%d %%{{/s}} %d %% commissions{{/strong}} on all referred sales", DEFAULT_COMMISSION, invite.commission), {
    strong: /*#__PURE__*/React.createElement("strong", {
      style: {
        color: "darkgreen"
      }
    }),
    s: /*#__PURE__*/React.createElement("s", {
      style: {
        color: "black"
      }
    })
  }) : _i(__("{{strong}}%d %% commissions{{/strong}} on all referred sales", DEFAULT_COMMISSION), {
    strong: /*#__PURE__*/React.createElement("strong", null)
  })), /*#__PURE__*/React.createElement("li", null, _i(__("Affiliate {{strong}}link tracking{{/strong}} with %d days attribution window (in accordance with the legal data protection regulations)", 14), {
    strong: /*#__PURE__*/React.createElement("strong", null)
  })), /*#__PURE__*/React.createElement("li", null, _i(__("{{strong}}Cookie-less{{/strong}} affiliate link tracking with {{code}}GET{{/code}} parameter forwarding"), {
    code: /*#__PURE__*/React.createElement("code", null),
    strong: /*#__PURE__*/React.createElement("strong", null)
  })), /*#__PURE__*/React.createElement("li", null, _i(__("{{strong}}Branded coupons{{/strong}} for exclusive discount (incl. tracking of sales)"), {
    strong: /*#__PURE__*/React.createElement("strong", null)
  })), /*#__PURE__*/React.createElement("li", null, _i(__("{{strong}}No payout fees{{/strong}} (for SEPA payouts in EUR) and monthly payouts"), {
    strong: /*#__PURE__*/React.createElement("strong", null)
  }))), /*#__PURE__*/React.createElement(Alert, {
    showIcon: true,
    type: "info",
    message: __("You can only become an affiliate at %s if you are an enterprise with valid proof (e.g. VAT ID, excerpt from the commercial register or trade license).", affiliateManufacturer.name)
  }));
});
export { AccountAffiliateSignUpSidebar };